export const ROLES = "/auth/Roles"
export const ROLE = "/auth/Role/:param"
